import { ProvidersFilterOptions } from "./enumerators";

export const ConvertProviderSourceFilterOptionsToDisplay: { [key: string]: string } = {
  [ProvidersFilterOptions.Network]: 'Network Providers',
  [ProvidersFilterOptions.Terminated]: 'Terminated Network Providers',
  [ProvidersFilterOptions.NonTerminated]: 'Non-Terminated Network Providers',
  [ProvidersFilterOptions.Market]: 'Market Providers',
  [ProvidersFilterOptions.AvailableMarket]: 'Available Market Providers',
  [ProvidersFilterOptions.TargetedMarket]: 'Targeted Market Providers',
  [ProvidersFilterOptions.ExcludedMarket]: 'Excluded Market Providers',
  [ProvidersFilterOptions.Prospect]: 'Prospect Providers',
  [ProvidersFilterOptions.AvailableProspect]: 'Available Prospect Providers',
  [ProvidersFilterOptions.TargetedProspect]: 'Targeted Prospect Providers',
  [ProvidersFilterOptions.ExcludedProspect]: 'Excluded Prospect Providers',
};
